import smoothscroll from "smoothscroll-polyfill";
import {getSiblings} from "@main/helpers/dom";
const {LG_WIDTH} = require("@main/helpers/const");

const TRANSITION_TIME = "0.4s";
const SCROLLTOP_TIMEOUT = 400;

export default class Accordion {
    constructor(el) {
        this.el = el;
        this.accordionButtons = this.el.querySelectorAll(".js-accordion-btn");
        this.accordionItems = this.el.querySelectorAll(".js-accordion-item");
        this.contents = this.el.querySelectorAll(".js-accordion-content");
        this.init();
    }

    init() {
        this.accordionButtons.forEach(btn =>
            btn.addEventListener("click", this.accordionBtnClickHandler)
        );

        window.addEventListener("resize", () => {
            this.accordionItems.forEach(item => {
                if (item.classList.contains("opened")) {
                    const content = item.querySelector(".js-accordion-content");
                    content.style.transition = "none";
                    content.style.maxHeight = `${content.scrollHeight}px`;
                }
            });
        });
    }

    accordionBtnClickHandler = e => {
        if (window.innerWidth >= LG_WIDTH && this.el.classList.contains("footer__info-wrap")) return;

        const currentBtn = e.target.closest(".js-accordion-btn");
        const parentItem = currentBtn.parentElement;
        const currentContent = parentItem.querySelector(
            ".js-accordion-content"
        );
        currentContent.style.transition = TRANSITION_TIME;

        this.accordionItems.forEach((item, index) => {
            const itemContent = this.contents[index];

            if (item !== parentItem) {
                item.classList.remove("opened");
            }

            if (itemContent && itemContent !== currentContent) {
                itemContent.style.maxHeight = 0;
            }
        });

        parentItem.classList.toggle("opened");

        const siblings = getSiblings(parentItem);
        siblings.forEach(sibling => {
            if (sibling.classList.contains("opened")) {
                if (this.el.closest(".js-cards-wrap") || this.el.closest(".management")) {
                    const rect = currentBtn.getBoundingClientRect(),
                        scrollTop = window.scrollY || document.documentElement.scrollTop,
                        top = rect.top + scrollTop;

                    if (!currentBtn.classList.contains("is-first")) {
                        window.scrollTo({
                            top: top - sibling.offsetHeight + parentItem.offsetHeight,
                            behavior: "smooth"
                        });
                    }
                }

                sibling.classList.remove("opened");
                sibling.querySelector(".js-accordion-content").style.maxHeight = 0;
            }
        });

        if (parentItem.classList.contains("opened")) {
            currentContent.style.maxHeight = `${currentContent.scrollHeight}px`;
        } else {
            currentContent.style.maxHeight = 0;
        }

        if (currentBtn.classList.contains("footer__info-btn")) {            
            setTimeout(() => {
                smoothscroll.polyfill();

                window.scrollTo({
                    top:
                        currentBtn.offsetTop -
                        document.querySelector(".header").clientHeight,
                    behavior: "smooth"
                });
            }, SCROLLTOP_TIMEOUT);
        }
    };
}

document.querySelectorAll(".js-accordion").forEach(item => new Accordion(item));
